export interface RoleActionTypes {
  type: RoleActions;
  payload?: any;
}

export enum RoleActions {
  CREATE_ROLE = "CREATE_ROLE",
  GET_ROLE_LIST = "GET_ROLE_LIST",
  SET_ROLE_LIST = "SET_ROLE_LIST",
  SET_ROLE_LIST_PAGE_COUNT = "SET_ROLE_LIST_PAGE_COUNT",
  GET_ROLE_DATA_BY_ID = "GET_ROLE_DATA_BY_ID",
  SET_ROLE_DATA_BY_ID = "SET_ROLE_DATA_BY_ID",
  EDIT_ROLE_DATA_BY_ID = "EDIT_ROLE_DATA_BY_ID",
  SET_DEPARTMENT_ID = "SET_DEPARTMENT_ID",
}
